<script>
// Helpers
import { getCountryCallingCode, parsePhoneNumber } from 'libphonenumber-js'
import _ from 'lodash'

// Data
import countries from '@/data/countries'
import examples from 'libphonenumber-js/examples.mobile.json'
import metadata from 'libphonenumber-js/metadata.mobile.json'

export default {
  props: ['value'],

  created() {
    this.initData()
  },

  data() {
    return {
      countryCode: countries[0].code,
      callingCode: null,
      mobileNumber: null,
      rules: {
        mobileNumber: [
          v => {
            return (
              (!!v && !!this.parseNumber(v) && !!this.parseNumber(v).isValid()) ||
              'must be a valid mobile number'
            )
          },
        ],
        code: [v => !!v || 'must select a country code'],
      },
    }
  },

  computed: {
    countries() {
      // https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#unsupported
      // FIX: 'AD' causes errors to be logged
      const unsupported = ['AQ', 'BV', 'TF', 'HM', 'PN', 'GS', 'UM', 'AD']
      return countries.filter(country => !unsupported.some(code => code === country.code))
    },

    placeholder() {
      if (!this.countryCode) return
      return this.parseNumber(examples[this.countryCode]).formatNational()
    },

    mask() {
      if (!this.placeholder) return
      return this.placeholder.replace(/\d/g, '#')
    },
  },

  watch: {
    value: _.debounce(function(value) {
      this.initData()
    }, 3000),

    countryCode() {
      // Validate form when country code changes
      this.$emit('validate')
      this.updateMobileNumber(this.mobileNumber)
    },
  },

  methods: {
    initData() {
      this.callingCode = this.value ? this.value.substring(0, 3).replace(/^0+/, '') : null
      try {
        if (this.callingCode) {
          this.countryCode = `${metadata.country_calling_codes[this.callingCode][0]}`
        }
        if (this.value && this.value.substring(3)) {
          this.mobileNumber = this.parseNumber(this.value.substring(3))
            .formatNational()
            .replace(/[^\d]/g, '')
        }
      } catch (error) {
        // Could not parse the value prop
      }
    },

    getCallingCode(countryCode) {
      if (!countryCode) return
      return getCountryCallingCode(countryCode)
    },

    updateMobileNumber(number) {
      this.$emit('input', `${this.getCallingCode(this.countryCode).padStart(3, '0')}${number}`)
    },

    updateCountryCode(code) {
      if (countries.some(country => country.code === code)) {
        this.countryCode = code
      }
    },

    parseNumber(mobileNumber = this.mobileNumber) {
      const number = mobileNumber ? mobileNumber.replace(/^0+/, '') : null
      try {
        return parsePhoneNumber(number, this.countryCode, metadata)
      } catch (error) {
        // Not a phone number, non-existent country, etc.
      }
    },

    countriesFilter(country, search) {
      return RegExp(`${search.replace(/[.*+?^${}()|[\]\\]/g, '')}`, 'i').test(
        [...Object.values(country), this.getCallingCode(country.code)].join('')
      )
    },
  },

  render() {
    return this.$scopedSlots.default({
      validator: {
        mobileNumber: this.mobileNumber,
        updateMobileNumber: this.updateMobileNumber,
        countries: this.countries,
        countryCode: this.countryCode,
        countriesFilter: this.countriesFilter,
        updateCountryCode: this.updateCountryCode,
        rules: this.rules,
        placeholder: this.placeholder,
        mask: this.mask,
        getCallingCode: this.getCallingCode,
      },
    })
  },
}
</script>
